import { render, staticRenderFns } from "./SelfDidSection.vue?vue&type=template&id=56b36210&scoped=true&"
import script from "./SelfDidSection.vue?vue&type=script&lang=js&"
export * from "./SelfDidSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b36210",
  null
  
)

export default component.exports